"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiQueue = void 0;
const MAX_RETRIES = 3;
const RETRY_DELAY = 500;
const MAX_BATCH_SIZE = 20;
class ApiQueue {
    queueName;
    apiCall;
    queue = [];
    processing = false;
    RAW_QUEUE_KEY = 'API_RAW_QUEUE';
    constructor(queueName, apiCall) {
        this.queueName = queueName;
        this.apiCall = apiCall;
        this.setupEventHandlers();
        const rawQueue = this.getQueue(this.rawQueueKey);
        this.queue = [...rawQueue];
    }
    setupEventHandlers() {
        if (typeof window === 'undefined')
            return;
        window.addEventListener('beforeunload', () => {
            this.syncRawQueue();
        });
        window.addEventListener('online', () => {
            if (!this.processing && this.queue.length > 0) {
                this.processing = true;
                void this.continuousFlush();
            }
        });
    }
    get rawQueueKey() {
        return `${this.RAW_QUEUE_KEY}_${this.queueName}`;
    }
    getQueue(key) {
        try {
            const stored = localStorage.getItem(key);
            if (!stored)
                return [];
            return JSON.parse(stored);
        }
        catch {
            return [];
        }
    }
    syncRawQueue() {
        this.setQueue(this.rawQueueKey, this.queue);
    }
    setQueue(key, data) {
        try {
            localStorage.setItem(key, JSON.stringify(data));
        }
        catch {
            // ignore localStorage errors
        }
    }
    addToQueue(data) {
        for (const item of data) {
            if (!this.queue.some((q) => JSON.stringify(q) === JSON.stringify(item))) {
                this.queue.push(item);
            }
        }
        this.syncRawQueue();
    }
    processQueue(sentItems) {
        this.queue = this.queue.filter((item) => !sentItems.some((sent) => JSON.stringify(sent) === JSON.stringify(item)));
        this.syncRawQueue();
    }
    async continuousFlush() {
        try {
            while (this.queue.length > 0) {
                const batch = this.queue.slice(0, MAX_BATCH_SIZE);
                let attempts = 0;
                while (attempts < MAX_RETRIES) {
                    try {
                        const response = await this.apiCall(batch);
                        if (response.success) {
                            this.processQueue(batch);
                            break;
                        }
                    }
                    catch (e) {
                        if (typeof navigator !== 'undefined' && !navigator.onLine) {
                            return;
                        }
                    }
                    attempts++;
                    await new Promise((r) => setTimeout(r, RETRY_DELAY));
                }
                if (attempts === MAX_RETRIES) {
                    this.queue.shift();
                    this.syncRawQueue();
                    continue;
                }
            }
        }
        finally {
            this.processing = false;
        }
    }
    async add(data) {
        this.addToQueue([data]);
        if (!this.processing) {
            this.processing = true;
            void this.continuousFlush();
        }
    }
    async flushViaBeacon(path) {
        if (this.queue.length === 0)
            return;
        try {
            const data = JSON.stringify(this.queue);
            if (navigator.sendBeacon) {
                const blob = new Blob([data], { type: 'application/json' });
                const beaconSent = navigator.sendBeacon(path, blob);
                if (beaconSent) {
                    this.queue = [];
                    this.syncRawQueue();
                }
            }
        }
        catch {
            // ignore errors
        }
    }
}
exports.ApiQueue = ApiQueue;
//# sourceMappingURL=api-queue.js.map